import { HAND_EXAMPLES } from '../utils/cards';

export function HelpModal({ isOpen, onClose, cardImageFolder = 'smallcards' }) {
  return (
    <div className={`modal example-modal ${isOpen ? 'open' : 'closed'}`}>
      <div className='modal-overlay' onClick={onClose}></div>
      <div className='modal-content'>
        <h2>How to play</h2>
        <p>Drag and drop your six cards correctly within the square to complete the <span className='hint'>required hands</span> both vertically and horizontally. Hands must contain five cards.</p>

        <hr />

        <h4>Example Hands</h4>

        <p><small>Card order does not matter within hands</small></p>

        {HAND_EXAMPLES.map((example, i) => (
          <div className='example' key={`example_${i}`}>
            <div className='example-top'>
              <div className='hint found'>{example.name}</div>
              <div className='grid'>
                {example.cards.map((card, j) => (
                  <div key={`example_${i}_card_${j}`} className='card'>
                    <img alt='' className='front' src={`./assets/${cardImageFolder}/${card}.png`} />
                  </div>
                ))}
              </div>
            </div>
            <p className='example-desc'><small>{example.desc}</small></p>
          </div>
        ))}

        <hr />

        <h4>Flipped Cards</h4>

        <p><small>
          Flipped cards can sometimes appear in puzzles, these are normal cards which stubbornly won't let you see their value. You'll have to take a guess, or work it out!
        </small></p>
        <div className='example'>
          <div className='example-top example-top-center'>
            <div className='grid'>
              {['th', 'jd', '??', 'kc', 'ad'].map((card, j) => (
                <div className='card' key={`example_flip_card_${j}`}>
                  <img alt='' className='front' src={card === '??' ? `./assets/${cardImageFolder}/back1.png` : `./assets/${cardImageFolder}/${card}.png`} />
                </div>
              ))}
            </div>
          </div>
        </div>

        <hr />

        <h4>Wild Cards</h4>

        <p><small>
          Wild cards can sometimes appear in puzzles, these may be used to represent any other playing card.
        </small></p>
        <p><small>
          If the wild card is shared across more than one hand, then it may represent multiple other playing cards simultaneously.
        </small></p>

        <div className='example'>
          <p className='example-desc'><small>In this example the wild card is repsenting a Queen, completing the <span className='hint found'>Straight</span> while also representing a Five to complete the <span className='hint found'>Three of a Kind</span>.</small></p>
          <br />
          <div className='example-top example-top-center'>
            <div className='grid'>
              {[
                'th', 'jd', 'or', 'kc', 'ad',
                '??', '??', '5d', '??', '??',
                '??', '??', '5h', '??', '??',
                '??', '??', '4c', '??', '??',
                '??', '??', '7c', '??', '??',
              ].map((card, j) => (
                <div className='card' key={`example_wild_card_${j}`}>
                  <img alt='' className='front' src={card === '??' ? `./assets/${cardImageFolder}/back1.png` : `./assets/${cardImageFolder}/${card}.png`} />
                </div>
              ))}
            </div>
          </div>
          <br />
        </div>

        <hr />

        <div className='modal-buttons'>
          <button onClick={onClose}>Return to Puzzle</button>
        </div>

        <p><small>Poqueta returns <span style={{ display: 'inline-block' }}>with a new puzzle every day.</span></small></p>

        <p>
          <small className='tiny'>
            Created by <a href='https://github.com/bogstandard/'>Bogstandard</a><br />
            Art by <b>Simon Spiers</b>
          </small>
        </p>
      </div>
    </div>
  );
}
